module.exports = __webpack_public_path__ + "static/Hop-b68c103d3e11224131d38d4911b9af2d.png";